import React from "react";

const ContextMenu = ({ position = "fixed", top, left, right, children }) => {
  return (
    <div
      style={{ top: top ? top + 24 : "auto", left: left ? left + 12 : "auto", right: right ? right : "auto" }}
      className={`${position} bg-white shadow-[0px_0px_10px_rgba(0,0,0,0.15)] rounded-lg dark:bg-black-800 min-w-[200px] z-[1] overflow-hidden animate-fade-in py-2`}>
      {children}
    </div>
  );
};

export default ContextMenu;
